import "./Home.css"
import { Link, useNavigate } from "react-router-dom";
import Slides from "../Components/slider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Calender } from "../Components/Githubcalender";
import Stat from "../Components/Stats";
import Tools from "../Components/Tools";
import Contact from "../Components/Contact";
import Projects from "../Components/Project_section";
import Typewriter from "typewriter-effect"
import myresume from "../file/Rekha-Yadav-Resume.pdf"
import About from "../Components/About";

function Home() {
    const handleResume=()=>{
        window.open("https://drive.google.com/file/d/1ROOVeuuELAGe2WC2oztiZTvbuX88dmGM/view?usp=sharing","_blank","noopener","noreferrer")
      }
    

    return (
        <>
            <div className="main" id="home">
                <div className="right_box">
                    <h1>REKHA YADAV</h1>
                    <p><Typewriter options={{autoStart:true,
                    loop:true,
                    delay:100,
                    strings:[
                        "I am a Full-Stack Web Developer",
                      
                    ]}}/></p>
                  <a href={myresume} onClick={handleResume} download target="_blank" rel="noopener noreferrer"><button className="btn1"onClick={()=>handleResume}>Resume</button></a>
                  <div className="socials">
                </div>
                </div>  
                <div className="left_box">
                    <img src="https://avatars.githubusercontent.com/u/101573056?v=4" alt="profile" />
                </div>
            </div>
           <About/>
            <Projects/>
            <Calender />
            <Stat />
            <Slides />
            <Tools/>
            <Contact/>
        </>
    )
}

export default Home

// old link  https://drive.google.com/file/d/16x1HAz0WviURA8xIgUz_zPMlzzbMXPSl/view?usp=sharing